let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jPZC4")).then(() => parcelRequire('fts3l'));